import { connect } from 'dva'
import PropTypes from 'prop-types'
import React, { useState, useRef } from 'react'

import { SIDEBAR_VIEWS } from '../../lib/constants'
import actions from './actions'
import DataManagerIcon from '../../assets/svg/DataManager'
import gohuntLogo from '../../assets/img/logo_maps_2x.png'
import LayerOrderIcon from '../../assets/svg/LayerOrder'
import LayersIcon2 from '../../assets/svg/LayerIcon2'
import MemoryMonitorIcon from '../../assets/svg/MemoryMonitor'
import styles from './ToolBar.module.scss'
import TerrainToolsIcon from '../../assets/svg/TerrainTools'
import TimeBackIcon from '../../assets/svg/TimeBack'
import ToolBarButton from './ToolBarButton'
import ToolBarInsiderPlusNav from './ToolBarInsiderPlusNav'
import useOnClickOutside from '../../lib/hooks/useOnClickOutside'
import User from '../../assets/svg/User'
import UserContent2 from '../../assets/svg/UserContent2'

const ToolBar = props => {
  const [showMapsMenu, setShowMapsMenu] = useState(false)
  const [insiderPlusPopupOpen, setInsiderPlusPopupOpen] = useState(false)
  const menuRef = useRef(null)

  useOnClickOutside(menuRef, () => {
    setShowMapsMenu(false)
  })

  const toggleMapsMenu = () => {
    setShowMapsMenu(!showMapsMenu)
  }

  const MapsMenu = () => {
    return (
      <div>
        <div>
          <a href={`${props.appConfig.REACT_APP_GOHUNT_CMS_URL}/dashboard`} rel='noopener noreferrer' target='_blank'>
            Home
          </a>
        </div>
        <div>
          <a href={`https://${props.appConfig.REACT_APP_GO2HUNT_SHOP_URL}`} rel='noopener noreferrer' target='_blank'>
            Shop
          </a>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.toolbar}>
      <div className={styles.mapsMenuContainer}>
        <img onClick={toggleMapsMenu} className={styles.gohuntLogo} src={gohuntLogo} width={40} height={40} />
        {showMapsMenu && (
          <div className={styles.mapsMenu} ref={menuRef}>
            <MapsMenu />
          </div>
        )}
      </div>
      <div>
        <div className={styles.iconBar}>
          <ToolBarButton
            title='Library'
            icon={LayersIcon2}
            view={SIDEBAR_VIEWS.Library}
            views={[
              SIDEBAR_VIEWS.Library,
              SIDEBAR_VIEWS.Overlays,
              SIDEBAR_VIEWS.LayerCategoryList,
              SIDEBAR_VIEWS.LayerCategoryDetail,
              SIDEBAR_VIEWS.AboutLocation
            ]}
          />
          <ToolBarButton
            title='Hunts'
            icon={UserContent2}
            view={SIDEBAR_VIEWS.Content}
            views={[
              SIDEBAR_VIEWS.Collection,
              SIDEBAR_VIEWS.Content,
              SIDEBAR_VIEWS.FeatureDetail,
              SIDEBAR_VIEWS.FeatureIconEditor,
              SIDEBAR_VIEWS.Saved,
              SIDEBAR_VIEWS.SelectedFeatures
            ]}
          />
          {props.hasTerrainRaster ? (
            <ToolBarButton title='Terrain Analysis' icon={TerrainToolsIcon} view={SIDEBAR_VIEWS.TerrainTools} views={[SIDEBAR_VIEWS.TerrainTools]} />
          ) : null}
          <ToolBarButton title='Historical Imagery' icon={TimeBackIcon} view={SIDEBAR_VIEWS.HistoricalImagery} views={[SIDEBAR_VIEWS.HistoricalImagery]} />
        </div>
        <div className={styles.iconBar}>
          <ToolBarButton
            title='Data Manager'
            icon={DataManagerIcon}
            view={SIDEBAR_VIEWS.DataManager}
            views={[SIDEBAR_VIEWS.DataManager, SIDEBAR_VIEWS.Import, SIDEBAR_VIEWS.Export]}
          />
          <ToolBarButton
            title='Account'
            icon={User}
            view={SIDEBAR_VIEWS.User}
            views={[SIDEBAR_VIEWS.User, SIDEBAR_VIEWS.Settings, SIDEBAR_VIEWS.Help, SIDEBAR_VIEWS.KeyboardShortcuts]}
          />
          <ToolBarInsiderPlusNav popupOpen={insiderPlusPopupOpen} onPopupOpenChange={setInsiderPlusPopupOpen} />
          {props.enableMemoryMonitor && (
            <ToolBarButton title='Memory Monitor' icon={MemoryMonitorIcon} view={SIDEBAR_VIEWS.MemoryMonitor} views={[SIDEBAR_VIEWS.MemoryMonitor]} />
          )}
          {props.enableLayerOrder && (
            <ToolBarButton title='Layer Order' icon={LayerOrderIcon} view={SIDEBAR_VIEWS.LayerOrder} views={[SIDEBAR_VIEWS.LayerOrder]} />
          )}
          {/* <ToolBarButton
            title="Help & Resources"
            icon={HelpIcon}
            view={SIDEBAR_VIEWS.Help}
          /> */}
        </div>
      </div>
    </div>
  )
}

ToolBar.propTypes = {
  appConfig: PropTypes.object,
  clickToolBarIcon: PropTypes.func,
  enableLayerOrder: PropTypes.bool,
  enableMemoryMonitor: PropTypes.bool,
  hasTerrainRaster: PropTypes.bool,
  sidebarHistory: PropTypes.array,
  sidebarView: PropTypes.object,
}

export default connect(model => {
  return {
    appConfig: model.app.config,
    enableLayerOrder: model.app.config.LAYER_ORDER_ENABLED === true,
    enableMemoryMonitor: model.app.config.MEMORY_MONITOR_ENABLED === true && model.app.config.SVG_CACHING_ENABLED === true,
    hasTerrainRaster: model.app.config.TERRAIN_TOOLS_RASTER != null && model.app.config.TERRAIN_TOOLS_RASTER !== '',
    sidebarHistory: model.app.sidebarHistoryStack,
    sidebarView: model.app.sidebarView,
  }
}, actions)(ToolBar)
